import React from "react";
import { motion } from "framer-motion";
import { Phone, MessageCircle, CalendarCheck } from "lucide-react";
import { COMPANY } from "@/data/site";
import { useLead } from "@/context/LeadContext";

export default function FloatingCTAs() {
  const { openLead } = useLead();
  return (
    <>
      {/* Desktop/side floating */}
      <div className="fixed right-4 bottom-24 z-40 hidden sm:flex flex-col gap-3">
        <motion.a
          href={`https://wa.me/${COMPANY.phoneRaw}?text=Hi%20JAL%20RAKSHAKK,%20I%20need%20waterproofing%20help`}
          target="_blank" rel="noreferrer"
          data-testid="float-whatsapp"
          className="h-14 w-14 rounded-full bg-[#25D366] flex items-center justify-center shadow-xl shadow-black/30"
          initial={{ scale: 0 }} animate={{ scale: 1 }} transition={{ delay: 1, type: "spring" }}
          whileHover={{ scale: 1.1 }}
        >
          <MessageCircle className="h-7 w-7 text-white" />
        </motion.a>
        <motion.a
          href={`tel:${COMPANY.phoneRaw}`}
          data-testid="float-call"
          className="h-14 w-14 rounded-full bg-royal flex items-center justify-center shadow-xl shadow-royal/40"
          initial={{ scale: 0 }} animate={{ scale: 1 }} transition={{ delay: 1.15, type: "spring" }}
          whileHover={{ scale: 1.1 }}
        >
          <Phone className="h-6 w-6 text-white" />
        </motion.a>
      </div>

      {/* Mobile sticky bottom bar */}
      <div className="fixed bottom-0 left-0 right-0 z-40 sm:hidden grid grid-cols-3 glass-dark border-t border-white/10" data-testid="mobile-cta-bar">
        <a href={`tel:${COMPANY.phoneRaw}`} className="flex flex-col items-center justify-center py-2.5 text-white text-xs gap-1 border-r border-white/10">
          <Phone className="h-5 w-5 text-sky" /> Call
        </a>
        <a href={`https://wa.me/${COMPANY.phoneRaw}`} className="flex flex-col items-center justify-center py-2.5 text-white text-xs gap-1 border-r border-white/10">
          <MessageCircle className="h-5 w-5 text-[#25D366]" /> WhatsApp
        </a>
        <button onClick={() => openLead("book_inspection")} className="flex flex-col items-center justify-center py-2.5 text-white text-xs gap-1 bg-royal">
          <CalendarCheck className="h-5 w-5" /> Book
        </button>
      </div>
    </>
  );
}
